import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as ticketPurchaseHistoryActions } from '../slices/TicketPurchaseHistorySlice';
import { actions as topUpHistoryActions } from '../slices/TopUpHistorySlice';
import { actions as reportTicketHistoryActions } from '../slices/ReportTicketHistorySlice';
import { actions as downloadReportTicketHistory } from '../slices/DownloadReportTicketHistorySlice';
import { actions as busNfcReportAction } from '../slices/BusNfcReportSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';

const getSearchCriteria = (state) => state.reportTicketHistory.searchCriteria;

function* getTicketPurchaseHistoryReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/orders`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: ticketPurchaseHistoryActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: ticketPurchaseHistoryActions.get_list_failed.type, payload: error });
    }
}

function* exportTicketPurchaseHistoryReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/orders`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: ticketPurchaseHistoryActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: ticketPurchaseHistoryActions.export_list_failed.type, payload: error });
    }
}

function* getTopUpHistoryReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/transactions`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: topUpHistoryActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: topUpHistoryActions.get_list_failed.type, payload: error });
    }
}

function* exportTopUpHistoryReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/transactions`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: topUpHistoryActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: topUpHistoryActions.export_list_failed.type, payload: error });
    }
}

function* getReportTicketHistory({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_export')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: reportTicketHistoryActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: reportTicketHistoryActions.get_list_failed.type, payload: error });
    }
}

function* exportReportTicketHistory({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_ticket_history')}`, {
            params: {
                ...params,
                export: true,
            },
        });
        yield put({ type: reportTicketHistoryActions.get_list_succeed.type, payload: { ...response.data } });
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: reportTicketHistoryActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: reportTicketHistoryActions.export_list_failed.type, payload: error });
    }
}

function* getNfcListReport({ payload: { page, size, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('nfc_list_report')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: size,
            },
        });
        yield put({ type: busNfcReportAction.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: busNfcReportAction.get_list_failed.type, payload: error });
    }
}

function* exporListNfcReport({ payload }) {
    try {
        const { filters } = payload;
        const response = yield NetworkHandler.get(`${config.getUrl('nfc_list_report')}`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: busNfcReportAction.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: busNfcReportAction.export_list_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(ticketPurchaseHistoryActions.get_list.type, getTicketPurchaseHistoryReport);
    yield takeLatest(ticketPurchaseHistoryActions.export_list.type, exportTicketPurchaseHistoryReport);
    yield takeLatest(topUpHistoryActions.get_list.type, getTopUpHistoryReport);
    yield takeLatest(topUpHistoryActions.export_list.type, exportTopUpHistoryReport);
    yield takeLatest(reportTicketHistoryActions.get_list.type, getReportTicketHistory);
    yield takeLatest(downloadReportTicketHistory.download_report_ticket_history.type, exportReportTicketHistory);
    yield takeLatest(busNfcReportAction.get_list.type, getNfcListReport);
    yield takeLatest(busNfcReportAction.export_list.type, exporListNfcReport);
}

export default watchRequestDetail;
